import { Transform, Type } from 'class-transformer';

import { booleanTransform, dateTransform } from '../utils/helper';
import { Associate, associate } from './associate.model';
import { Doctor } from './doctor.model';
import { Patient, patient } from './patient.model';
import { Volunteer, volunteer } from './volunteer.model';

export class Actor {
	id!: number;
	name!: string;
	surname!: string;
	cf!: string;
	piva?: string;
	@Transform(dateTransform)
	dob?: Date;
	gender?: string;
	cityofresidence?: string;
	cityofbirth?: string;
	cap?: string;
	vat?: string;
	address?: string;
	studylevel?: string;
	mobile?: string;
	landline?: string;
	uid?: number;
	email?: string;
	@Transform(booleanTransform)
	client?: boolean;
	@Transform(booleanTransform)
	supplier?: boolean;
	@Transform(booleanTransform)
	legalperson?: boolean;
	bank?: string;
	iban?: string;
	paymnetmethod?: string;
	@Transform(booleanTransform)
	privacy?: boolean;
	@Transform(booleanTransform)
	medicalcertificate?: boolean;
	job?: string;
	typeofdegree?: string;
	degree?: string;
	documenttype?: string;
	@Transform(dateTransform)
	issuedate?: Date;
	@Transform(dateTransform)
	expirydate?: Date;
	issueauthority?: string;
	documentnumber?: string;
	categorysupplier?: string;
	alternativeaddress?: string;
	associateid?: number;
	patientid?: number;
	volunteerid?: number;
	doctorid?: number;
	@Transform(dateTransform)
	insdate?: Date;
	@Transform(dateTransform)
	moddate?: Date;
	photo?: string;
	previewurl?: string;
	note?: string;
	regionaldoctorcode?: string;
	suppliercertificate?: string;
	@Transform(booleanTransform)
	supplierqualification?: boolean;
	supplierscore?: number;
	@Transform(dateTransform)
	supplierdate?: Date;
	suppliercategory?: string;
	@Transform(booleanTransform)
	groupinginvoice?: boolean;
	@Transform(booleanTransform)
	candrive?: boolean;
	hqid?: number;
	@Transform(booleanTransform)
	qualificaraccoltafondi?: boolean;

	@Type(volunteer)
	volunteer!: Volunteer;

	@Type(associate)
	associate!: Associate;

	@Type(patient)
	patient!: Patient;

	@Type(() => Doctor)
	doctor!: Doctor;

	get fullname(): string {
		return `${this.name} ${this.surname}`;
	}

	get fullAddress(): string {
		const a = this.address ? (this.address + ', ') : '';
		const r = this.cityofresidence ? (this.cityofresidence + ' ') : '';
		const c = this.cap ? ` ${this.cap}` : '';
		return `${a}${r}${c}`;
	}

}

export enum ActorTypes {
	VOLUNTEER = 'volunteer',
	ASSOCIATE = 'associate',
	PATIENT = 'patient',
	DOCTOR = 'doctor'
}